// src/components/MiPlanPanel.jsx
import React from "react";
import { useTranslation } from "react-i18next";

export default function MiPlanPanel() {
  const { t, i18n } = useTranslation();

  // Fechas de ejemplo (ajusta si vienen de Firestore)
  const renewalDate = new Date("2025-07-06T00:00:00");

  const renewalStr = renewalDate.toLocaleDateString(i18n.language || "es", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="config-section">
      <div className="config-card">
        <div className="config-card-title">{t("plan.title", "Mi Plan")}</div>
        <div className="config-card-body">
          <div>
            {t("plan.current", "Plan actual")}: <strong>Premium</strong>
          </div>
          <div>
            {t("plan.renewal", "Renovación")}: <strong>{renewalStr}</strong>
          </div>
        </div>
      </div>
    </div>
  );
}
